import styled, { css } from 'styled-components';

import {
  color,
  layout,
  space,
  ColorProps,
  SpaceProps,
  LayoutProps,
  typography,
  TypographyProps,
  flexbox,
  FlexboxProps,
} from '../../style/mixins';

interface HeadingBaseProps
  extends ColorProps, SpaceProps, TypographyProps, LayoutProps, FlexboxProps {
  light?: boolean;
}

export const HeadingBase = styled.div<HeadingBaseProps>`
  line-height: 1.25;

  ${color}
  ${layout}
  ${space}
  ${typography}
  ${flexbox}

  ${({ light }) =>
    light &&
    css`
      color: ${({ theme }) => theme.color.fg.secondary};
    `}
`;

HeadingBase.defaultProps = {
  fontWeight: 'medium',
  mb: 2,
  mt: 0,
};

export const H1 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h1',
}))``;
H1.defaultProps = { fontSize: ['heading1.sm', 'heading1.m', 'heading1.l'] };

export const H2 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h2',
}))``;
H2.defaultProps = { fontSize: ['heading2.sm', 'heading2.m', 'heading2.l'] };

export const H3 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h3',
}))``;
H3.defaultProps = { fontSize: ['heading3.sm', 'heading3.m', 'heading3.l'], fontWeight: 400 };

export const H4 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h4',
}))``;
H4.defaultProps = { fontSize: 'title2', fontWeight: 400 };

export const H5 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h5',
}))``;
H5.defaultProps = { fontSize: 'body1', mb: 0 };

export const H6 = styled(HeadingBase).attrs<{ as: string }>((props) => ({
  as: props.as || 'h6',
}))``;
H6.defaultProps = { fontSize: 'body2' };
